/* Polsk katalog for locale-supplier-country-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  "purchaseDocs.removeAll": "Usuń wszystkie",
  "purchaseDocs.removeOne": "Usuń {name} z zakupu",
  "purchaseDocs.duplicateTitle": "Możliwy podwójny zapis",
  "purchaseDocs.duplicateHelp": "Sprawdź wcześniejsze zakupy. Nadal możesz zaksięgować.",
  "purchaseDocs.sameAttachment": "Ten sam plik załączono więcej niż raz.",
  "purchaseDocs.sameFile": "Ten sam plik jest użyty w dokumencie {number} · {date}.",
  "purchaseDocs.sameDetails": "Dokument {number} · {date} ma tę samą datę i kwotę.",
  "purchaseFlow.listTitle": "Lista zakupów",
  "purchaseFlow.purchaseCount": "Zakupy",
  "purchaseFlow.netPurchases": "Zakupy netto",
  "purchaseFlow.netPurchasesHelp": "Bez VAT, po korektach",
  "purchaseFlow.includingVat": "Z VAT",
  "purchaseFlow.credited": "Skorygowano",
  "purchaseFlow.creditable": "Pozostało do skorygowania",
  "purchaseFlow.creditAllocationHelp": "Wybierz fakturę przed księgowaniem, aby rozliczyć ją automatycznie. Nadwyżka ponad nieopłacone saldo pozostanie należnością od dostawcy.",
  "err.supplierCredit.invalidAmount": "Kwota korekty musi być dodatnia i nie może przekroczyć kwoty jeszcze nieskorygowanej. Płatności nie zmniejszają tego limitu.",
  "err.purchase.duplicateSupplierDocument": "Ten numer dokumentu jest już zarejestrowany dla dostawcy. Otwórz istniejącą fakturę lub korektę.",
  'purchaseFlow.creditNote': 'Korekta',
  "purchaseFlow.negativeWarning": "Ujemna kwota faktury jest nietypowa, chyba że jest to korekta.",
  "purchaseFlow.creditOriginal": "Korygowana faktura (opcjonalnie)",
  "purchaseFlow.standaloneCredit": "Bez powiązania – nadpłata u dostawcy",
  "purchaseFlow.creditLinesRequired": "Użyj nowych ujemnych pozycji i zaksięguj bezpośrednio. Szkice i edycja nie są tutaj obsługiwane.",
  "err.supplierCredit.unsupportedLines": "Użyj zwykłych pozycji zakupu. Zapasy, aktywa i szczególne rozliczenia VAT wymagają osobnej korekty.",
  'registry.toggleSupplierHelp': 'Podpowiada norweskie firmy podczas wpisywania nazwy dostawcy lub numeru organizacyjnego.',
  'sup.foreignToggle': 'Dostawca zagraniczny',
  'sup.foreignToggleHelp': 'Włącz dla dostawców zarejestrowanych w innym kraju niż Twoja firma.',
  'sup.countryCode': 'Kod kraju',
  'sup.countryCodePh': 'Np. SE lub US',
  'sup.countryRequired': 'Podaj dwuliterowy kod kraju zagranicznego dostawcy.',
  'sup.registrationNumber': 'Numer rejestrowy',
  'sup.registrationNumberPh': 'Zagraniczny numer rejestrowy dostawcy',
  'sup.vatNumber': 'Numer VAT',
  'sup.vatNumberPh': 'Np. SE123456789001',
});
